AFRAME.registerComponent('watchlist-input-popup', {
    init: function() {
        this.config = {};
        this.el.setAttribute('visible', false);
        this.el.setAttribute('scale', '0 0 0');

        this.el.sceneEl.addEventListener('theme-changed', () => {
            if (this.el.getAttribute('visible')) {
                this.render();
            }
        });
    },

    setup: function(config) {
        this.config = config;
    },

    open: function() {
        this.render();
        const input = document.querySelector('#vr-watchlist-generic-input');
        if (input) {
            input.value = this.config.initialValue || '';
            const textDisplay = this.el.querySelector('#vr-generic-text-display');
            if (textDisplay) {
                textDisplay.setAttribute('value', input.value);
            }
            if (typeof this.updateSize === 'function') {
                this.updateSize(input.value);
            }
        }
    },

    close: function() {},

    render: function() {
        this.el.innerHTML = '';
        const isLight = (typeof getCacheItem === 'function' && getCacheItem('mainSettings')?.themeMode === 'Light');
        const bgColor = isLight ? '#F5F5F5' : '#111';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';

        const bg = document.createElement('a-rounded-plane');
        bg.setAttribute('width', 0.6);
        bg.setAttribute('height', 0.4);
        bg.setAttribute('position', '-0.3 -0.2 0');
        bg.setAttribute('color', bgColor);
        bg.setAttribute('radius', 0.02);
        this.el.appendChild(bg);
        this._bg = bg;

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', this.config.title || 'Input');
        title.setAttribute('font-size', 0.04);
        title.setAttribute('color', txtColor);
        title.setAttribute('position', '0 0.14 0.01');
        title.setAttribute('anchor', 'center');
        this.el.appendChild(title);

        const inputFocusBorder = document.createElement('a-rounded-box');
        inputFocusBorder.setAttribute('width', 0.52);
        inputFocusBorder.setAttribute('height', 0.10);
        inputFocusBorder.setAttribute('depth', 0.004);
        inputFocusBorder.setAttribute('color', '#3636E3');
        inputFocusBorder.setAttribute('position', '0 0.04 0.009');
        inputFocusBorder.setAttribute('radius', 0.012);
        inputFocusBorder.setAttribute('visible', false);
        this.el.appendChild(inputFocusBorder);
        this._inputFocusBorder = inputFocusBorder;

        const inputBox = document.createElement('a-rounded-box');
        inputBox.setAttribute('width', 0.5);
        inputBox.setAttribute('height', 0.08);
        inputBox.setAttribute('depth', 0.005);
        inputBox.setAttribute('color', isLight ? '#DDD' : '#333');
        inputBox.setAttribute('position', '0 0.04 0.01');
        inputBox.setAttribute('radius', 0.01);
        inputBox.setAttribute('data-raycastable', '');
        this.el.appendChild(inputBox);
        this._inputBox = inputBox;

        const textDisplay = document.createElement('a-troika-text');
        textDisplay.setAttribute('id', 'vr-generic-text-display');
        textDisplay.setAttribute('value', '');
        textDisplay.setAttribute('font-size', 0.035);
        textDisplay.setAttribute('color', txtColor);
        textDisplay.setAttribute('position', '0 0.04 0.015');
        textDisplay.setAttribute('anchor', 'center');
        this.el.appendChild(textDisplay);

        const hitbox = document.createElement('a-entity');
        hitbox.setAttribute('position', '0 0.04 0.02');
        hitbox.setAttribute('geometry', 'primitive: plane; width: 0.5; height: 0.08');
        hitbox.setAttribute('html', 'html:#vr-watchlist-generic-input; cursor:#cursor');
        hitbox.setAttribute('material', 'shader: flat; opacity: 0; transparent: true');
        hitbox.setAttribute('data-raycastable', '');
        this.el.appendChild(hitbox);
        this._hitbox = hitbox;

        const buttons = document.createElement('a-entity');
        buttons.setAttribute('position', '0 -0.12 0.02');
        this.el.appendChild(buttons);

        const cancelBtn = document.createElement('a-entity');
        cancelBtn.setAttribute('position', '-0.12 0 0');
        cancelBtn.setAttribute('ui-button', {
            label: 'Cancel',
            width: 0.18,
            height: 0.07,
            colorScheme: 'primary',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        cancelBtn.addEventListener('click', () => window.WatchlistApp.Popup.closeManual('watchlist-input-vr-popup'));
        buttons.appendChild(cancelBtn);

        const confirmBtn = document.createElement('a-entity');
        confirmBtn.setAttribute('position', '0.12 0 0');
        confirmBtn.setAttribute('ui-button', {
            label: this.config.confirmText || 'OK',
            width: 0.18,
            height: 0.07,
            colorScheme: 'accent',
            type: 'rounded-box',
            depth: 0.02,
            radius: 0.015,
            preferredFontSize: 0.04
        });
        confirmBtn.addEventListener('click', () => {
            const val = document.querySelector('#vr-watchlist-generic-input').value;
            if (this.config.onConfirm) this.config.onConfirm(val);
            window.WatchlistApp.Popup.closeManual('watchlist-input-vr-popup');
        });
        buttons.appendChild(confirmBtn);

        this.setupInputLogic();
    },

    updateSize: function(text) {
        const textStr = text || '';
        const minChars = 25;
        const charWidth = 0.022;
        const baseInputWidth = 0.5;
        
        let targetInputWidth = baseInputWidth;
        if (textStr.length > minChars) {
            targetInputWidth = baseInputWidth + (textStr.length - minChars) * charWidth;
        }

        const bgWidth = targetInputWidth + 0.1;
        const borderTargetWidth = targetInputWidth + 0.02;

        if (this._bg) {
            this._bg.setAttribute('width', bgWidth);
            this._bg.setAttribute('position', `${-bgWidth / 2} -0.2 0`);
        }
        if (this._inputFocusBorder) {
            this._inputFocusBorder.setAttribute('width', borderTargetWidth);
        }
        if (this._inputBox) {
            this._inputBox.setAttribute('width', targetInputWidth);
        }
        if (this._hitbox) {
            this._hitbox.setAttribute('geometry', `primitive: plane; width: ${targetInputWidth}; height: 0.08`);
        }
    },

    setupInputLogic: function() {
        const input = document.querySelector('#vr-watchlist-generic-input');
        const textDisplay = this.el.querySelector('#vr-generic-text-display');
        if (input) {
            input.value = this.config.initialValue || '';
            input.oninput = (e) => {
                if (textDisplay) {
                    textDisplay.setAttribute('value', e.target.value);
                }
                this.updateSize(e.target.value);
            };
            if (textDisplay) {
                textDisplay.setAttribute('value', input.value);
            }
            this.updateSize(input.value);
            input.onfocus = () => {
                if (this._inputFocusBorder) this._inputFocusBorder.setAttribute('visible', true);
            };
            input.onblur = () => {
                if (this._inputFocusBorder) this._inputFocusBorder.setAttribute('visible', false);
            };
        }
    }
});
